<template>

    <div>

        HELLO!

        <video
            ref="videoPlayer"
            id="telesur-embedded-video"
            class="player-fit vjs-big-play-centered"
            controls
            preload="auto"
        >
            <p class="vjs-no-js">
                To view this video please enable JavaScript, and consider upgrading to a
                web browser that
                <a href="https://videojs.com/html5-video-support/" target="_blank"
                >supports HTML5 video</a
                >
            </p>
        </video>

    </div>



</template>

<script>

    export default {

        data () {

            return {

                /*ENV_CloudFront_Legacy_DNS_Name: 'https://telesur-vod-legacy-assets.s3.amazonaws.com/',
                ENV_CloudFront_DNS_Name: 'https://telesur-vod-streaming-assets.s3.amazonaws.com/'*/

                ENV_CloudFront_Legacy_DNS_Name: process.env.MIX_LEGACY_CLOUDFRONT_DNSNAME,
                ENV_CloudFront_DNS_Name: process.env.MIX_CLOUDFRONT_DNSNAME
            }
        },

        props: [
            'currentlocale'
        ],

        computed: {

            mediaSrc() {
                if(!this.$root.shared.isLegacyContent) {
                    /*return process.env.MIX_CLOUDFRONT_DNSNAME + this.$root.shared.playerPayload.storage_url*/
                    /*return this.ENV_CloudFront_DNS_Name + this.$root.shared.playerPayload.storage_url;*/
                    return this.ENV_CloudFront_DNS_Name + '/hello';
                } else {
                    /*return process.env.MIX_LEGACY_CLOUDFRONT_DNSNAME + this.$root.shared.playerPayload.storage_url*/
                    /*return this.ENV_CloudFront_Legacy_DNS_Name + this.$root.shared.playerPayload.storage_url;*/
                    return this.ENV_CloudFront_Legacy_DNS_Name + '/hello';
                }
            },

            player () {
                return this.$refs.videoPlayer.player
            },

            src() {
                /*this.mediaSrc = process.env.MIX_CLOUDFRONT_DNSNAME + this.$root.shared.playerPayload.storage_url*/
                this.mediaSrc = this.ENV_CloudFront_DNS_Name + this.$root.shared.playerPayload.storage_url
            },

            playerOptions() {

                if(!this.$root.shared.isLegacyContent) {
                    return {
                        autoplay: false,
                        controls: true,
                        controlBar: {
                            timeDivider: false,
                            durationDisplay: false,
                        },
                        fluid: true,
                        /*poster: process.env.MIX_CLOUDFRONT_DNSNAME + this.$root.shared.playerPayload.thumbnail_url*/
                        poster: this.ENV_CloudFront_DNS_Name + this.$root.shared.playerPayload.thumbnail_url
                    }
                } else {
                    return {
                        autoplay: false,
                        controls: true,
                        controlBar: {
                            timeDivider: false,
                            durationDisplay: false,
                        },
                        fluid: true
                    }
                }
            },

        },

        methods: {

            playVideo: function (source) {

                if(this.$root.shared.isLegacyContent) {
                    const video = {
                        withCredentials: false,
                        type: 'video/mp4',
                        src: source,
                    }

                    this.player.src(video)

                } else {
                    const video = {
                        withCredentials: false,
                        type: 'application/x-mpegurl',
                        src: source,
                    }

                    this.player.src(video)
                }
            }

        },

        mounted () {
            this.playVideo(this.mediaSrc)
        }

    }

</script>

<style scoped>

.player {
    /* position: absolute !important; */
    width: 100%;
    height: 60%;
}

.vjs-custom-skin {
    height: 60% !important;
}

.vjs-custom-skin /deep/ .video-js {
    height: 60%;
}

.player-fit {
    position: relative !important;
    width: 100% !important;
    height: auto !important;
}

</style>
